import React from "react"
import classnames from "classnames"
import styles from "./CorporateSelect.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { InputText, Space, InputCheckBox, A, Button, InputSelect, H3, P, CheckBoxGroup, FormGroup, InputEmail } from "AtomicComponents"
import { AlertList, DealerSearch } from "AtomicContainers"
import InputSearchable from "../InputSearchable/InputSearchable"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import componentParser from "AtomicUtils/componentParser"
import MESSAGES from "AtomicConstants/MESSAGES"
import TITLES from "./TITLES"

class CorporateSelect extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        businessName: {
          validations: {
            required: MESSAGES.BUSINESS_REQUIRED,
            businessName: MESSAGES.BUSINESS_INVALID
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        models: {
          validations: {
            required: MESSAGES.MODEL_REQUIRED
          }
        },
        region: {
          validations: {
            required: MESSAGES.DEALERS_NO_POSTCODE
          }
        },
        dealer: {
          validations: {
            required: MESSAGES.DEALERS_REQUIRED
          }
        },
        comments: {
          validations: {
          }
        },
        optIn: {
          validations: {
            required: MESSAGES.OPTIN_REQUIRED
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  _handleSubmit = async (event) => {
    const { buttonText = "Send enquiry" } = this.props
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { submitFormEndpoint, models } = this.props
        const { form } = this.state

        let body = {
          title: form.title.value,
          firstName: form.firstName.value,
          lastName: form.lastName.value,
          businessName: form.businessName.value,
          phone: form.phone.value,
          email: form.email.value,
          models: form.models.value,
          dealerLocation: form.dealer.value.id,
          dealerCode: form.dealer.value.dealerCode,
          postCode: form.dealer.value.postCode,
          suburb: form.dealer.value.suburb,
          state: form.dealer.value.state,
          comments: form.comments.value
        }

        await fetchAPI({
          method: "POST",
          url: submitFormEndpoint,
          body: body
        })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              loading: false
            })
          } else {
            // successful
            this.setState({
              loading: false,
              success: true
            }, () => {
              gtmHandler({
                pageCategory: "Corporate select Form",
                pageAction: `Corporate select Form - Clicked "${buttonText.toUpperCase()}" - Successfully submitted.`
              })

            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            loading: false
          })
        })
      })
    }
  }

  _handleOnBlurCheckBoxGroup = () => {
    const { form } = this.state
    if (form && form.models && form.models.value && form.models.value.length) {
      gtmHandler({
        pageCategory: "Corporate Form",
        pageAction: `Corporate Form - Selected "MODELS" - "${form.models.value.map(item => (item.toUpperCase() + " "))}"`
      })
    }
  }

  _handleOnBlurSearchableRegion = (value) => {
    if (value && value.display) {
      gtmHandler({
        pageCategory: "Corporate Form",
        pageAction: `Corporate Form - Selected "DEALER" - "${value.display.toUpperCase()}"`
      })
    }

    if (value && value.description){
      gtmHandler({
        pageCategory: "Corporate Form",
        pageAction: `Corporate Form - Selected "POSTCODE/SUBURB" - "${value.description.toUpperCase()}"`
      })
    }
  }

  render() {
    const {
      title, description, models, privacyPolicy, privacyPolicyLink, dealersEndPoint = "/api/dealer-search", dealerApiEndPoint, optInText, buttonText = "Contact us", thankYouComponents
    } = this.props
    const { loading, form, success, errorMessage } = this.state

    if (success) {
      return componentParser(thankYouComponents)
    }

    return (
      <div className={classnames({
        [styles.CorporateSelect]: true
      })}>
        <H3 withDetails>{title}</H3>
        <P>{description}</P>
        <div className={classnames({
          [styles.CorporateSelectForm]: true
        })}>
          <form method="POST" onSubmit={this._handleSubmit} noValidate>
            <FormGroup>
              <InputSelect
                name="title"
                label="Title"
                options={TITLES}
                {...fromLinkInputs(this, "title")}
                onBlur={()=>{
                  if (form.title.value) {
                    gtmHandler({
                      pageCategory: "Corporate select Form",
                      pageAction: `Corporate select Form - Selected "TITLE" - "${form.title.value.toUpperCase()}"`
                    })
                  }
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="firstName"
                label="First Name"
                {...fromLinkInputs(this, "firstName")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Entered \"FIRSTNAME\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="lastName"
                label="Last Name"
                {...fromLinkInputs(this, "lastName")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Entered \"LASTNAME\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="businessName"
                label="Business Name"
                {...fromLinkInputs(this, "businessName")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Entered \"Business Name\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="phone"
                label="Phone"
                {...fromLinkInputs(this, "phone")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Entered \"PHONE\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputEmail
                name="email"
                label="Email"
                {...fromLinkInputs(this, "email")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Entered \"EMAIL\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <CheckBoxGroup
                heading="Select model(s) of interest"
                items={models}
                {...fromLinkInputs(this, "models")}
                onBlur={this._handleOnBlurCheckBoxGroup} />
            </FormGroup>
            <FormGroup>
              <InputSearchable
                name="region"
                type="dealer"
                dealersEndPoint={dealersEndPoint}
                label="Enter your postcode, suburb or Dealer name"
                {...fromLinkInputs(this, "region")}
                onBlur={this._handleOnBlurSearchableRegion}
              />
            </FormGroup>
            <FormGroup>
              <DealerSearch
                dealersEndPoint={dealersEndPoint}
                endpoint={dealerApiEndPoint}
                disabled={!form.region.value || !(form.region.value.postcode || form.region.value.value)}
                type="Sales"
                name="dealer"
                postcode={form.region.value && form.region.value.postcode || (initialLocations && initialLocations[0] && initialLocations[0].postCode)}
                dealerCode={form.region.value && form.region.value.value}
                {...fromLinkInputs(this, "dealer")} />
            </FormGroup>
            <FormGroup>
              <InputText
                name="comments"
                label="Tell us your enquiry"
                {...fromLinkInputs(this, "comments")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Entered \"ENQUIRY\""
                  })
                }}
              />
            </FormGroup>
            <Space />
            <FormGroup show checkbox>
              <InputCheckBox
                name="optIn"
                label={optInText || "I acknowledge that Mazda or Mazda dealers may send me further information about Mazda products or services."}
                {...fromLinkInputs(this, "optIn", () => {
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - checked \"Opt in\""
                  })
                })}
              />
            </FormGroup>
            <Space />
            <FormGroup show checkbox>
              <InputCheckBox
                name="privacy"
                label={
                  <span>
                    {privacyPolicy}{" "}
                    <A
                      href={privacyPolicyLink}
                      onClick={()=>{
                        gtmHandler({
                          pageCategory: "Corporate select Form",
                          pageAction: "Corporate select Form - Clicked \"PRIVACYPOLICY\""
                        })
                      }}
                      external>
                        <nobr>Privacy Policy</nobr>
                    </A>
                  </span>
                }
                {...fromLinkInputs(this, "privacy", () => {
                  gtmHandler({
                    pageCategory: "Corporate select Form",
                    pageAction: "Corporate select Form - Checked \"PRIVACYPOLICY\""
                  })
                })}
              />
            </FormGroup>
            <Space />
            <Space />
            <FormGroup>
              <AlertList data={errorMessage} />
              <Button
                styleName="black"
                loading={loading}
                fullWidth
                {...formLinkSubmit(this, this._handleSubmit)}
              >
                {buttonText}
              </Button>
            </FormGroup>

          </form>
        </div>
      </div>
    )
  }
}

export default CorporateSelect



// WEBPACK FOOTER //
// ./src/AtomicContainers/CorporateSelect/CorporateSelect.jsx